import React from 'react';
export const BonusesSection = () => {
  const bonuses = [{
    num: '01',
    icon: '📄',
    title: 'Cheat Sheets Definitivos',
    desc: 'Python 3.12, Java 21 y SQL en hojas de referencia rápida. Todo lo que necesitás saber de los 3 lenguajes para tener a mano en cualquier examen.',
    price: '$15.000 ARS'
  }, {
    num: '02',
    icon: '📅',
    title: 'Planificador de Cuatrimestre',
    desc: 'Sistema completo para organizar tu cuatrimestre semana a semana. Tracker de materias, countdown de finales, dashboard de progreso y alertas configurables.',
    price: '$15.000 ARS'
  }, {
    num: '03',
    icon: '🤖',
    title: '50 Prompts de IA para Programar Más Rápido',
    desc: 'Los prompts exactos para depurar código, entender teoría difícil, preparar exámenes orales y simular entrevistas técnicas con ChatGPT y Claude.',
    price: '$15.000 ARS'
  }];
  return <section className="bg-megapack-section py-10 md:py-16 px-4 md:px-6" data-id="element-17">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-18">
        <div className="text-center mb-10 md:mb-16" data-id="element-19">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-20">
            🎁 MÁS LOS 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-megapack-gray text-[15px] md:text-lg" data-id="element-21">
            Incluidos siempre — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-22">
          {bonuses.map((b, i) => <div key={i} className="bg-megapack-card border border-megapack-gold/20 p-6 md:p-8 rounded-2xl relative flex flex-col" data-id="element-23">
              <div className="absolute -top-3 left-6 md:left-8 bg-megapack-gold text-megapack-bg font-bold text-xs py-1 px-3 rounded" data-id="element-24">
                {b.num}
              </div>
              <div className="text-4xl md:text-5xl mb-4 md:mb-6 mt-2" data-id="element-25">
                {b.icon}
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4" data-id="element-26">
                {b.title}
              </h3>
              <p className="text-megapack-gray text-[14px] md:text-sm leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-27">
                {b.desc}
              </p>
              <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-white/5" data-id="element-28">
                <span className="text-megapack-red line-through text-sm" data-id="element-29">
                  {b.price}
                </span>
                <span className="text-megapack-green font-bold" data-id="element-30">GRATIS</span>
              </div>
            </div>)}
        </div>

        <div className="bg-megapack-bg border-2 border-megapack-gold rounded-2xl p-6 md:p-8 text-center max-w-md mx-auto" data-id="element-31">
          <p className="text-megapack-gray text-sm mb-2" data-id="element-32">
            Valor total de los 3 Bonos
          </p>
          <p className="text-megapack-red text-2xl md:text-3xl font-bold line-through mb-3 md:mb-4" data-id="element-33">
            $45.000 ARS
          </p>
          <div className="bg-megapack-gold text-megapack-bg font-bold py-3 px-6 rounded-xl mb-3 md:mb-4 text-base md:text-lg" data-id="element-34">
            🎁 GRATIS — Incluidos con tu compra hoy
          </div>
          <p className="text-megapack-gray text-xs" data-id="element-35">
            En todas las compras del Mega Pack.
          </p>
        </div>
      </div>
    </section>;
};